import React from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import { ACTION_MENU_ITEMS } from '../../constants/NotificationsConst';
import './Action-Menu-List.scss';

const ActionMenuList = ({ anchorEl, handleClose, handleAction, actionMenuItems }) => {
  return (
    <Menu
      id='Action Menu'
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      className='list-action-menu'
    >
      {actionMenuItems?.map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            handleAction(item);
            handleClose();
          }}
          className='list-action-menu-item'
        >
          {ACTION_MENU_ITEMS[item?.toLowerCase()]}
          {item}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ActionMenuList;
